<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="meunTitle2"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="test"></div>
          <el-tabs
            v-loading="tableLoading"
            v-model="activeName"
            class="elTabs"
            @tab-click="getUserId"
          >
            <el-tab-pane label="详情" :name="ais_info.id">
              <detail-list
                v-bind:ais_info="ais_info"
                v-if="ais_info.id"
              ></detail-list>
              <!-- <el-tab-pane label="校友邮箱" name="second">配置管理</el-tab-pane>
            <el-tab-pane label="校友帐号" name="third">角色管理</el-tab-pane>
            <el-tab-pane label="操作日志" name="fourth">定时任务补偿</el-tab-pane>-->
            </el-tab-pane>
            <el-tab-pane
              :label="'详情' + (index + 2)"
              :name="item.id"
              v-for="(item, index) in sons"
              :key="index"
            >
              <detail-list v-bind:ais_info="item" v-if="item"></detail-list>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";
import { response } from "@/utils/resUtils.js";
import detailList from "@/pages/dataMgr/detailList";

var del_ais_education = [];
var del_ais_job_info = [];
var del_ais_journal = [];
var del_ais_honor = [];

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    detailList,
  },
  data() {
    return {
      tableLoading: false,
      userid: "",
      meunItem: {},
      meunTitle: "校友基本信息列表",
      meunTitle2: "校友详情",
      activeName: "",
      ais_info: {}, //个人信息
      sons: [],
      getId: "",
    };
  },
  methods: {
    initData(meunItem) {
      // debugger
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.userid = this.meunItem.userid;
      this.activeName = this.userid;
      console.log(meunItem);
      this.getAisInfoById();
    },
    // 获取基础信息
    getAisInfoById: function () {
      this.tableLoading = true;
      this.$api
        .getAisInfoById({
          token: localStorage.getItem("token"),
          id: this.userid,
          // id: localStorage.getItem("id")
        })
        .then(({ data }) => {
          this.ais_info = data.Data;
          this.sons = data.Data.son;
          this.tableLoading = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
        });
    },
    getUserId() {
      this.meunItem.userid = this.activeName;
      localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
    },
  },
};
</script>
<style lang="less" scoped>
.elTabs {
  margin-top: -40px;
}
.test {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
</style>
<style>
.elTabs .is-top {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/userDetails.vue